require('./aggregatorAccountBox.scss');

import React from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';

// @components
import { AggregatorGenericBox } from '../aggregatorGenericBox/aggregatorGenericBox';
import { AggregatorAccountDetails } from 'components/aggregator/aggregatorDetails/aggregatorAccountDetails/aggregatorAccountDetails';
import { OneLineSymbolAmount } from 'commonsComponents/oneLineSymbolAmount';
import { LoadingSection } from 'commonsComponents/loadingSection';

//@commons
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';

// @ helpers
import { formatAmountObject, getPlainAmountObject } from 'utilities/currencyHelper';
import { getLastNChars } from 'utilities/stringHelper';
import { formatDate } from 'utilities/dateHelper';
import { sendTextToClipBoard } from 'commonsUtilities/clipBoardHelper';

const { FormattedText } = require('core/i18n').i18n;

class AggregatorAccountBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleCopyIbanToClipBoard = this.handleCopyIbanToClipBoard.bind(this);
    this.buildTooltipContent = this.buildTooltipContent.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  handleCopyIbanToClipBoard() {
    sendTextToClipBoard(this.props.account);
  }

  buildTooltipContent(iban) {
    return (
      <span>
        {iban}
        <button
          className="icon__tooltip icon-copiar"
          onClick={this.handleCopyIbanToClipBoard}
        ></button>
      </span>
    );
  }

  renderHeader() {
    const { account, id, alias, balance, lastUpdate, history } = this.props;

    const ibanFormatted = (
      <span className="aggregator-accounts-box-header__iban">{getLastNChars(`${account}`)}</span>
    );
    const tooltipContent = this.buildTooltipContent(account);
    const plainAmountObject = balance && getPlainAmountObject(balance);

    return (
      <div
        className="aggregator-accounts-box-header"
        onClick={() => history.push(`/myprofile/global/entities/accounts/${id}`)}
        id={id}
      >
        <section>
          <div className="clearfix">
            <div className="pull-left">
              <div>
                <Link
                  className="aggregator-accounts-box-header__alias"
                  to={'/myprofile/global/entities/accounts/' + id}
                >
                  {alias}
                </Link>
              </div>
              <div>
                <OKTooltip
                  content={tooltipContent}
                  offset={[120, 10]}
                  placement="bottom"
                  target={ibanFormatted}
                />
              </div>
            </div>
            <div className="pull-right">
              <div>
                <FormattedText
                  className="aggregator-accounts-box-header__balance-title"
                  value="accordionAccount-balance"
                />
              </div>
              {!!plainAmountObject && (
                <div>
                  <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    className="aggregator-accounts-box-header__balance-value"
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
        <section className="aggregator-accounts-box-header__subtype">
          <span>
            <FormattedText
              value="aggregatorAccountsDetails-lastUpdate"
              injectedStrings={[formatDate(lastUpdate)]}
            />
          </span>
        </section>
      </div>
    );
  }

  renderBody() {
    const { details, id, isTinkAggregator } = this.props;

    if (!details) return <LoadingSection />;

    return (
      <div className="aggregator-accounts-box-body">
        <AggregatorAccountDetails
          details={details}
          productId={id}
          isTinkAggregator={isTinkAggregator}
        />
      </div>
    );
  }

  render() {
    const { onExpand, id } = this.props;

    return (
      <AggregatorGenericBox
        header={this.renderHeader()}
        body={this.renderBody()}
        onExpand={onExpand}
        id={id}
      />
    );
  }
}

AggregatorAccountBox.propTypes = {
  account: PropTypes.string,
  id: PropTypes.string,
  alias: PropTypes.string,
  balance: PropTypes.object,
  lastUpdate: PropTypes.string,
  details: PropTypes.object,
  history: PropTypes.object.isRequired,
  onExpand: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

export default withRouter(AggregatorAccountBox);
